import { render, staticRenderFns } from "./BuscarMovimentoCompra.vue?vue&type=template&id=34544522"
import script from "./BuscarMovimentoCompra.vue?vue&type=script&lang=js"
export * from "./BuscarMovimentoCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports